import { render, staticRenderFns } from "./PersonDetailsCard.vue?vue&type=template&id=ccf93374&scoped=true&"
import script from "./PersonDetailsCard.vue?vue&type=script&lang=js&"
export * from "./PersonDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonDetailsCard.vue?vue&type=style&index=0&id=ccf93374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf93374",
  null
  
)

export default component.exports